import React from 'react'
import DocSearchDynamicGroupRow from './DocSearchDynamicGroupRow'
import SarasMenu from '../../../../library/repeater/menu/SarasMenu'
import { Icon } from '../../../../library/decor/SarasIcons';
import SarasChip from '../../../../library/repeater/list/SarasChip';
import SarasTrans from '../../../../library/notifications/SarasTrans';

const DocSearchDynamicGroup = (props) => {
    const { dynamicGroupManager, dynamicTriigerAnchorRef, 
            level, nodePath, deviceInfo,
            isDynamicTrigger, onClose} = props;

    const onGroupSelect = (e, index) => {
        // Reset the selection for all levels
        let groupRowClicked = dynamicGroupManager.dynamicGroupData[Object.keys(dynamicGroupManager.dynamicGroupData)[index]];
        if (!groupRowClicked) return;

        dynamicGroupManager.onGroupSelect(level || 0, nodePath, groupRowClicked.dataList.key);
    }

    const shouldHideOption = (event, row) => {
        if (!row || !row.dataList || !row.dataList.key) return false;

        if(!level || level === 0) return false; // Don't hide options for the first level
        
        const groupKey = row.dataList.key;
        const selectedGroupKeys = Object.values(dynamicGroupManager.dynamicGroupSelection || {});
        
        // Hide if this group key is already selected at any level
        return selectedGroupKeys.includes(groupKey);
    }
    
    const renderGroupTrigger = () => {
        let DropdownIcon = Icon['arrowmenu'];
        let group = dynamicGroupManager.getSelectedGroupLabels();

        return (
            <>
                <span className='uiActionWithMenu uiFlexBox3 uiHover'>
                    <span className=''><SarasTrans value="Group" /></span> <DropdownIcon className='uiBrandColor1'/>
                    {group && false ? <SarasChip className='uiDynamicGroupChip' data={{ key: group, val: deviceInfo.activateMobileView ? "" : group }} onDelete={() => dynamicGroupManager.onClearGroupSelection()} /> : null}
                </span>
            </>
        )
    }

    return (
        <>
            <SarasMenu menuContainerClass="uiInLine" menuTrigger={isDynamicTrigger ? null : renderGroupTrigger()} 
                isDynamicTrigger={isDynamicTrigger} dynamicTriigerAnchorRef={dynamicTriigerAnchorRef}
                dataList={Object.values(dynamicGroupManager.dynamicGroupData)} 
                initialSelectedIndex={dynamicGroupManager.getLevel0KeyIndex()}
                onShouldHideOption={shouldHideOption}
                trackSelection={true}
                key={level || 0}
                onClose={onClose}
                menuItem={DocSearchDynamicGroupRow} onSelection={onGroupSelect}
                contentStyle={{width:"250px",maxHeight:"300px",overflowY:"scroll"}}
            ></SarasMenu>
        </>
    )
}

export default DocSearchDynamicGroup